import React, { useEffect, useRef, useState } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import styled from "styled-components";

const Style = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    padding: 1rem 70px 1rem;
    width: calc(100% - 140px);
    margin: 0 auto;
    isolation: isolate;
    background-color: var(--n-bg-1);
    min-height: 200px;
    .box {
        flex-grow: 1;
        position: relative;
        padding: 3rem;
        overflow: hidden;
        border-radius: 8px;
        isolation: isolate;
        display: flex;
        border: 1px solid #D9D9D9;
    }
    .bg-img {
        position: absolute;
        left: 1rem;
        top: 0;
        width: 300px;
        height: 300px;
        opacity: 0.3;
        img {
            display: block;
            height: 100%;
            width: 100%;
            object-fit: fill;
        }
    }
    .title {
        width: 40%;
        z-index: 5;
        font-size: 1.5rem;
        font-weight: 800;
        letter-spacing: 1px;
        display: flex;
        align-items: center;
        &.pr {
            letter-spacing: 0;
        }
    }
    .items {
        min-height: calc(100px + 1rem);
        width: 60%;
        grid-gap: var(--grid-gap);
        grid-row-gap: var(--grid-row-gap);
        justify-content: center;
        .groupslide {
            width: 100%;
            position: relative;
            .main-slide{
                position: absolute;
                top: 0;
                left: calc(50% - 50px);
                transition: all 0.9s ease-in-out;
                img {
                    padding: 0.5rem 4rem;
                    border-radius: 0.5rem;
                    background-color: #fff;
                    box-shadow: var(--n-shadow-1);
                    width: 100px;
                    height: 100px;
                    display: block;
                    object-fit: fill;
                }
            }
            .slider-enter {
                opacity: 0;
                left: -10rem;
            }
            .slider-enter-active {
                opacity: 1;
                left: calc(calc(50% - 50px) - 4rem);
            }
            .slider-enter-done{
                opacity: 1;
                left: calc(calc(50% - 50px) - 4rem);
            }
            .slider-exit{
                opacity: 1;
                left: calc(calc(50% - 50px) - 4rem);
            }
            .slider-exit-active{
                opacity: 0;
                left: calc(100% + 10rem);
            }
            .slider-exit-done{
                opacity: 0;
                left: calc(100% + 10rem);
            }
        }
        
    }

    @media (max-width: 850px){
        padding: 1rem 16px 1rem;
        width: calc(100% - 32px);
        .bg-img {
            left: 0;
            width: 100%;
        }
        .box {
            padding: 1rem 1rem 1rem;
            flex-direction: column;
        }
        .title {
            width: 100%;
            margin-bottom: 1rem;
        }
        .items {
            width: 100%;
        }
    }
`;

export default function CenterItemsImage2({language,data}) {
    const [selected, setSelected] = useState(0);
    const refrence = useRef();
    const refrenceTime = useRef();
    const [refs, setRefs] = useState([]);
    useEffect(() => {
        if(data.data.length){
            let nrefs = [];
            for (let i = 0; i < data.data.length; i++) {
                nrefs.push(React.createRef());
            }
            setRefs(nrefs);
        }
        refrence.current = 0;
        let inter = setInterval(newItem, 500);
        return () => {clearInterval(inter)}
    }, []);
    useEffect(() => {
        if(refrence.current !== selected){
            setSelected(refrence.current);
        }
    }, [refrence.current])
    const newItem = () => {
        let time = refrenceTime.current;
        if(!time){
            time = 0
        }
        if(Date.now() >  time + 1800){
            let newSelected = refrence.current + 1;
            if(newSelected > data.data.length - 1){
                newSelected = 0;
            }
            refrence.current = newSelected
            refrenceTime.current = Date.now();
        }
    }


    const makeCards = () => {
        return (
            <TransitionGroup className="groupslide">
                <CSSTransition
                    key={selected}
                    classNames={"slider"}
                    timeout={900}
                    nodeRef={refs[selected]}
                >
                    <div ref={refs[selected]} className="main-slide" key={selected} item-data={selected}>
                        <img src={data.data[selected].image} alt={data.data[selected].title}/>
                    </div>
                </CSSTransition>
            </TransitionGroup>
        )
    }
    let lan = language.filename;
    return (
      <Style>
        <div className="box">
            <div className="bg-img">
                <img src={data.image} alt="companies"/>
            </div>
            <div className={`title ${lan}`}>
                {data.title}
            </div>
            <div className="items">
                {makeCards()}
            </div>
        </div>
      </Style>
  );
}
